import React from "react";

function InfoCard({ title, desc, icon, customClass }) {
  return (
    <div className={`${customClass} guide-card`}>
      <div className="guide-icon-bg">
        <img src={icon} alt={title} />
      </div>
      <p className="guide-card-title">{title}</p>
      <p className="guide-card-desc">{desc}</p>
    </div>
  );
}

export default InfoCard;
